<template>
  <pvd-loading-spinner
    active="true"
    type="brand"
    class="mt-4"
  />
</template>
<script>

import dataHelper from '../mixins/dataHelper';

export default {
  name: 'Retrieve',
  mixins: [
    dataHelper,
  ],
};

</script>

<style scoped>
  .mt-4{
    margin-top: 4rem;
  }
</style>
